'use client';

import styled from 'styled-components';

const Divider = styled.hr.attrs({
  'data-mesh-component': 'DIVIDER'
})`
  margin: 0;
  border: none;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
`;

Divider.displayName = 'Divider';

export default Divider;
